import { render } from "./ManifestShipmentTable.vue?vue&type=template&id=6b43397d&scoped=true"
import script from "./ManifestShipmentTable.vue?vue&type=script&lang=js"
export * from "./ManifestShipmentTable.vue?vue&type=script&lang=js"

import "./ManifestShipmentTable.vue?vue&type=style&index=0&id=6b43397d&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b43397d"]])

export default __exports__